import { Component, Input } from '@angular/core';
import { UiApprovalStep } from '../../models/ui-document-panel.model';

@Component({
  selector: 'app-ui-approval-stepper',
  templateUrl: './ui-approval-stepper.component.html',
  styleUrls: ['./ui-approval-stepper.component.scss']
})
export class UiApprovalStepperComponent {
  @Input() steps: UiApprovalStep[] = [];
}
